import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function DiagnosticProcess() {
  const dealershipApproach = ['Higher labor rates', 'High volume, rotating staff', 'Longer appointment waits', 'No inspection report in your hands'];
  const lancerApproach = ['Competitive independent shop pricing', 'Same shop, same technicians over time', 'Most appointments available within 24 hours', 'Direct communication, plain-English explanations', 'Full Digital Vehicle Inspection sent to your phone', "OEM and aftermarket diagnostic tools — the same technical coverage you'd get at a dealership"];
  return <section id="diagnostic-process" className="py-20 px-4 bg-brand-dark text-white" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-24">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-25">
            An alternative to the dealership
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold mb-6" data-id="element-26">
            Toyota expertise without the dealership price tag.
          </h2>
          <div className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto space-y-4" data-id="element-27">
            <p data-id="element-28">
              Dealerships know their vehicles. They also charge more for labor,
              book out further, and run high enough volume that you're rarely
              talking to the same person twice.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mb-16" data-id="element-29">
          {/* Dealership Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-800/50 border border-gray-700 rounded-2xl p-8 md:p-10 flex flex-col" data-id="element-30">
            <h3 className="font-heading uppercase tracking-wide text-xl font-bold text-gray-400 mb-8 pb-4 border-b border-gray-700" data-id="element-31">
              Dealership
            </h3>
            <ul className="space-y-6 flex-grow" data-id="element-32">
              {dealershipApproach.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-33">
                  <XCircleIcon className="w-6 h-6 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-34" />
                  <span className="text-gray-300 font-medium text-lg" data-id="element-35">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Lancer's Approach Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-800 border-2 border-brand-accent rounded-2xl p-8 md:p-10 relative shadow-2xl shadow-brand-accent/10" data-id="element-36">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-bold px-4 py-1 rounded-full text-sm" data-id="element-37">
              Lancer Service
            </div>
            <h3 className="font-heading uppercase tracking-wide text-xl font-bold text-white mb-8 pb-4 border-b border-gray-700" data-id="element-38">
              Independent Shop
            </h3>
            <ul className="space-y-6" data-id="element-39">
              {lancerApproach.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-40">
                  <CheckCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-41" />
                  <span className="text-white font-medium text-lg" data-id="element-42">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto space-y-4 text-center" data-id="element-43">
          <p data-id="element-44">
            Lancer gives you the same depth of Toyota knowledge in a shop where
            you'll know exactly what was inspected, what was found, and what it
            costs before anyone touches your car. We've been in St. Paul since
            1977, and a lot of our Toyota customers have been coming here for
            years.
          </p>
          <p data-id="element-45">
            A lot of them came to us as a second opinion first — after a dealer
            visit that left them with a diagnosis that didn't feel right, or a
            noise that "couldn't be found," or a suspension concern that got
            brushed off. We take those calls seriously. Finding what someone
            else missed is something we're good at.
          </p>
        </motion.div>
      </div>
    </section>;
}